/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as OauthImport } from './routes/oauth'
import { Route as AccountsImport } from './routes/accounts'
import { Route as IndexImport } from './routes/index'
import { Route as AccountsAccountIdImport } from './routes/accounts/$accountId'

// Create Virtual Routes

const AboutLazyImport = createFileRoute('/about')()

// Create/Update Routes

const AboutLazyRoute = AboutLazyImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const OauthRoute = OauthImport.update({
  path: '/oauth',
  getParentRoute: () => rootRoute,
} as any)

const AccountsRoute = AccountsImport.update({
  path: '/accounts',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/accounts.lazy').then((d) => d.Route))

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const AccountsAccountIdRoute = AccountsAccountIdImport.update({
  path: '/$accountId',
  getParentRoute: () => AccountsRoute,
} as any).lazy(() =>
  import('./routes/accounts/$accountId.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/accounts': {
      preLoaderRoute: typeof AccountsImport
      parentRoute: typeof rootRoute
    }
    '/oauth': {
      preLoaderRoute: typeof OauthImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/accounts/$accountId': {
      preLoaderRoute: typeof AccountsAccountIdImport
      parentRoute: typeof AccountsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AccountsRoute.addChildren([AccountsAccountIdRoute]),
  OauthRoute,
  AboutLazyRoute,
])

/* prettier-ignore-end */
